import { Table } from "react-bootstrap";
import Laoder from "../../../components/loading/Loader";
import useFilterParams from "../../../hooks/useFilterParams";
import jalaliTime from "../../../functions/jalaliTime";

function DigikalaCoworkerListTable({ items, count, isFetching }) {
  const filters = useFilterParams();

  return (
    <section className="pt-4">
      <p className="mb-0 px-1 fw-bold text-success">
        <span>تعداد: </span>
        <span>{count.toLocaleString()}</span>
      </p>
      <div className="w-100 px-1 overflow-x-auto">
        <Table striped bordered className="text-center">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره سفارش</th>
              <th>ثبت کننده</th>
              <th>سرویس دهنده</th>
              <th>بارکد</th>
              <th>فرستنده</th>
              <th>گیرنده</th>
              <th>مبلغ فاکتور</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {isFetching && (
              <tr>
                <td colSpan="9">
                  <Laoder />
                </td>
              </tr>
            )}

            {isFetching === false &&
              items.map((item, idx) => (
                <tr key={item.id}>
                  <td>
                    {idx +
                      1 +
                      (filters.getParam("page") - 1) *
                        filters.getParam("items")}
                  </td>
                  <td>{item.numberParcel}</td>
                  <td>{item.user.name + " " + (item.user.family ?? "")}</td>
                  <td>{item.company.name}</td>
                  <td>{item.barcode}</td>
                  <td>
                    <span>{item.source.name}</span>
                    <span> {item.source.family} - </span>
                    <span>{item.source.province.faName}</span>
                    <span> {item.source.city.faName}</span>
                  </td>

                  <td>
                    <span>{item.destination.name}</span>
                    <span> {item.destination.family} - </span>
                    <span>{item.destination.province.faName}</span>
                    <span> {item.destination.city.faName}</span>
                  </td>
                  <td>
                    {(item.realPayable + item.amountCOD).toLocaleString()}
                  </td>
                  <td>{jalaliTime(item.created_at).full}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </section>
  );
}
export default DigikalaCoworkerListTable;
